
import Vue from 'vue'
import ElementUI from 'element-ui';
import store from '../store/store'
import axios from '@/plugins/axios'

//localStorage
export const setStore = (name, content) => {
  if ( !name ) return;
  if (typeof content != 'string' ) {
    content = JSON.stringify(content);
  }
  localStorage.setItem(name, content);
}
//localStorage
export const getStore = name => {
  if (!name) return;
  return localStorage.getItem(name);
}
//localStorage
export const removeStore = name => {
  if (!name) return;
  localStorage.removeItem(name);
}


//删除数组的某一元素
export const Arrayremove = (arr, val) => {
  var index = arr.indexOf(val);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
};


//地址选择去零
export const removeZero = (item) => {
  return item.replace(/\b(0+)/gi, "");
}
//地址code加0

export const addZero = (item) => {
  return item.padStart(6, "0");
}

//数字字符串转数字类型
export const numChange = (num) => {
  return Number(num);
}

//数字价格类型处理
export const numPrice = (num) => {
  let reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
  if (reg.test(num)) {
    return true;
  } else {
    return false;
  }
}
//数字字符串验证
export const numDeal = (num) => {
  let reg = /(^[1-9]\d*$)|(^0$)/;
  if (reg.test(num)) {
    return true;
  } else {
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/plugins/mutils.js